import { Typography } from "antd";
import AlertNotification from "./AlertNotification";

const VMAInfo = ({ id, desc, title, date, url, notification }) => {
  const divStyle = {
    borderBottom: "2px solid",
    borderColor: "white",
    padding: "10px",
    margin: "20px",
  };
  const parsedTime = date && convertTime(date);

  notification === true &&
    id &&
    AlertNotification(id, title, desc, parsedTime, "VMA");

  return (
    <div style={divStyle}>
      <Typography.Title level={5} className="tileHeader">
        {title}
      </Typography.Title>
      <p className="tileP">Utfärdat: {parsedTime}</p>
      <p className="tileP">{desc}</p>
      <a href={url}>{url}</a>
    </div>
  );
};
function convertTime(timestamp) {
  let slicedtime = parseInt(timestamp.slice(6, 19));
  let dateObj = new Date(slicedtime);
  return (
    dateObj.getDate() +
    "/" +
    (dateObj.getMonth() + 1) +
    " kl " +
    dateObj.getHours() +
    ":" +
    dateObj.getMinutes()
  );
}

export default VMAInfo;
